// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "ГОД В ЦИФРАХ",
    "note": "*Все данные приведены по состоянию на 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nВы впервые сыграли в KKPoker в 2025-м году."
  },
  "report": {
    "loginTime": "С тех пор вы провели в KKPoker\n{loginDay}",
    "loginTips": "*Дни, проведенные в KKPoker в 2025 году.",
    "enjoyTime": "{loginTime}\n— ваше любимое время! В это время вы чаще всего заходили в KKPoker!",
    "firstHandDate": "{first_hand_date}\nПервая рука в этом году была в формате {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "За год в KKPoker вы сыграли \n{hands}\nВаша любовь к покеру сильнее, чем у\n{percentage} игроков.",
    "v2": "За год в KKPoker вы сыграли \n{hands}\nСпасибо, что идёте с нами по этому пути!",
    "v3": "За этот год в KKPoker вы сыграли \n{hands}\nKKPoker постарается улучшить и сделать ваш опыт ещё более приятным в следующем году."
  },
  "hardTime": {
    "date": "{one_day_hands}\nЭто был ваш самый преданный день в KKPoker.",
    "hands": "В этот день вы сыграли \n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Из всех раздач {handsNum}\nсыграно в вашем любимом формате: \n{game}",
  "kkWin": {
    "v1": "В 2025 году вы получили КК\n{all} {longTimes}\nи победили соперников с помощью КК\n{win} {longTimesTwo}",
    "v2": "В этом году вы пошли олл-ин\n{all} {threeTimes}\nПроцент побед при олл-ине:\n{percentage}\nПокер — игра для отважных!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nстало для вас самым удачным днем.",
    "spinup_2": "Вы получили множитель {spinup_ratio} в SpinUp и выиграли\n{spinup_reward}",
    "mtt": "{mtt_date}\nстало для вас главным днем в году!",
    "mtt_2": "В тот день\nвы заняли {mtt_rank}{no} место в {mtt_name}\nи выиграли\n{mtt_reward}",
    "rg": "{rg_date}\nЗаметный день в вашем покерном пути!",
    "rg_2": "Вы сорвали самый крупный банк в году:\n{rg_reward}"
  },
  "lucky": {
    "title": "Каждая рука рассказывает \nсвою историю.",
    "luckyHand": "СЧАСТЛИВАЯ\nРУКА",
    "unLuckyHand": "НЕВЕЗУЧАЯ\nРУКА",
    "luckyRate": "Процент побед\n {lucky_rate}",
    "unLuckyRate": "Процент побед\n{unlucky_rate}",
    "luckyText": "{lucky_hand} стали лучшими.\nКогда они у тебя на руках, твой винрейт достигает {lucky_rate}!",
    "unLuckyText": "Остерегайся {unlucky_hand}…\nС ними ты выигрывал лишь {unlucky_rate} раз!",
    "note": "*В расчет берутся только стартовые руки, розданные хотя бы 10 раз."
  },
  "futureStory": "KKPoker с нетерпением ждет продолжения вашей покерной истории в 2026 году!",
  "version3": {
    "text": "К сожалению, вы не оставили никаких воспоминаний с KKPoker в 2025 году.",
    "continue": "Приходите писать следующую главу\nвашего покерного пути в 2026 году!",
    "tips": "**Все данные актуальны на 2024-12-31."
  },
  "button": {
    "save": "Снимок",
    "copy": "Скопировать и поделиться"
  },
  "unit": {
    "days": "д",
    "hands": "раздач",
    "longHands": "раздач",
    "longTimes": "р",
    "longTimesTwo": "р",
    "threeTimes": "р",
    "times": "р",
    "multiplier": "множитель",
    "num": "-е",
    "num2": "",
    "bets": "",
    "skUnits": "игроков"
  },
  "toast": {
    "linkCopied": "Ссылка скопирована",
    "imageSaved": "Снимок сохранен"
  }
}
  